import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { Row, StackProps } from "@rui/Stack";

export const ChapterHeading = styled(Stack)(({ theme, onClick }) => ({
  padding: "2px 4px",
  borderRadius: "4px",
  "&:hover": onClick
    ? {
        cursor: "pointer",
        backgroundColor: theme.palette.shades.ghost[300],
      }
    : { cursor: "default" },
}));

export const ChapterHeader = styled("li")(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[700],
  fontWeight: 500,
  marginRight: "6px",
  listStyle: "none",
}));

export const ChapterTitle = styled((props: StackProps) => (
  <Row variant="left" {...props} />
))(({ theme, onClick }) => ({
  width: "fit-content",
  padding: "2px 4px",
  borderRadius: "4px",
  "&:hover": onClick
    ? {
        cursor: "pointer",
        backgroundColor: theme.palette.shades.ghost[300],
      }
    : { cursor: "default" },
}));

export const ChapterDescription = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamilySecondary,
  color: theme.palette.shades.neutral[600],
  lineHeight: 19 / 16,
  padding: "2px 4px",
}));
